"use strict";

exports.__esModule = true;
exports.default = void 0;
var _ssr = require("@restart/ui/ssr");
var _default = _ssr.SSRProvider;
exports.default = _default;
module.exports = exports.default;